import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function AccessDenied({ role }) {
  return (
    <main className="max-w-3xl mx-auto px-6 py-16" data-testid="squad-denied">
      <div className="flat-card p-10 text-center scanlines">
        <Lock size={28} color="var(--amber)" strokeWidth={1.5} className="mx-auto" />
        <div className="overline mt-4">// ACCESS_DENIED</div>
        <h1 className="font-display font-bold text-3xl uppercase mt-2">Leader Console Restricted</h1>
        <p className="text-[var(--text-2)] mt-3">
          The Squad Console is reserved for <span className="text-white">Leader</span> and <span className="text-white">Admin</span> roles.
          Your role: <span className="font-mono text-[var(--cyan)]">{role || "unknown"}</span>
        </p>
        <Link to="/dashboard" className="btn-ghost mt-6 inline-block" data-testid="squad-back-dashboard">
          ← Back to Ops
        </Link>
      </div>
    </main>
  );
}
